import moment from "moment";
import React from "react";
import { marpolSelectors } from "../../../../../redux/app/marpol";
import {
	EBFL1RecordState,
	TBFL1Record,
} from "../../../../../redux/app/bfl-1/@types";
import { TBFL1D2 } from "../../../../../redux/app/bfl-1/groups/group-d";
import BFL1TableRows, { BFL1TableColumns } from "../BFL1TableRows";
import { IStore } from "../../../../../redux/store";
import { ConnectedProps, connect } from "react-redux";
import BFL1Previewer from "../BFL1Previewer";

type OwnProps = {
	bfl1Record: TBFL1Record;
	isStrikedOff?: boolean;
};
type BFL1D2PreviewProps = React.PropsWithChildren<OwnProps>;
function BFL1D2Preview(props: BFL1D2PreviewProps & PropsFromRedux) {
	const bfl1Record = props.bfl1Record as TBFL1D2;
	const operationDate = moment(bfl1Record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);
	const dateOfOriginalOperation = moment(
		bfl1Record.itemD2.dateOfOriginalOperation,
		"YYYY-MM-DD"
	).format("DD-MMM-YYYY");

	function renderMain() {
		return (
			<>
				<BFL1TableRows
					record={bfl1Record}
					tableRows={[
						[dateOfOriginalOperation, "I", "-", renderItemMain()],
						[...renderMissedPlaceholder()],
						[null, null, "NOTE", bfl1Record.remarks],
					]}
				/>
				{renderMissedRecord()}
			</>
		);
	}

	function renderItemMain() {
		return (
			<h4 className="font-medium uppercase">
				ENTRY PERTAINING TO AN EARLY INCORRECT OPERATIONAL ENTRY
				{bfl1Record.itemD2.receiptAttachment &&
				bfl1Record.itemD2.receiptAttachment !== " " ? (
					<>
						<br />
						CORRECTION NOTE: {bfl1Record.itemD2.receiptAttachment}
					</>
				) : null}
			</h4>
		);
	}

	function renderMissedPlaceholder(): BFL1TableColumns {
		const canShowPlaceholder =
			bfl1Record.itemD2.isAnMissedEntryRecord &&
			!bfl1Record.itemD2.missedRecord;
		if (!canShowPlaceholder) return [null, null, null, null];

		const content = (
			<h4 className="font-medium text-gray-500 uppercase">
				<div className="flex flex-row items-center justify-center p-6 px-12 font-medium text-center bg-gray-100 border-2 border-gray-400 border-dashed">
					<div>MISSED ENTRY WILL APPEAR HERE</div>
					<span className="ml-6 text-gray-400 bp3-icon bp3-icon-time"></span>
				</div>
			</h4>
		);

		return [
			operationDate,
			<div className="text-gray-500">?</div>,
			<div className="text-gray-500">?</div>,
			content,
		];
	}

	function renderMissedRecord() {
		if (!bfl1Record.itemD2.missedRecord) return null;
		return (
			<BFL1Previewer
				bfl1Record={{
					...bfl1Record.itemD2.missedRecord,
					selectedDate: bfl1Record.selectedDate,
					state: props.isStrikedOff
						? EBFL1RecordState.STRIKED_OFF
						: bfl1Record.itemD2.missedRecord.state,
				}}
			/>
		);
	}

	return renderMain();
}

function mapStateToProps(store: IStore) {
	const marpolStore = marpolSelectors._getStore(store);

	return {};
}
const reduxConnector = connect(mapStateToProps, {});
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(BFL1D2Preview);
